module.exports = __webpack_public_path__ + "static/media/icon3.d16ad720.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/newpage/icon3.png
// module id = 217
// module chunks = 0